"use strict";import{tag as s}from"../custom-tag.js";export function signOutIcon({height:t=16,width:r=16,hidden:l=!1,title:e="Sign out"}={}){return s`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${r}
      height=${t}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${e}"
    >
      <g clip-path="url(#sign-out_svg__clip0_3955_5550)">
        <mask
          id="sign-out_svg__mask0_3955_5550"
          width="21"
          height="22"
          x="2"
          y="1"
          maskUnits="userSpaceOnUse"
          style="mask-type:alpha"
        >
          <path
            fill="currentColor"
            stroke="currentColor"
            stroke-width=".25"
            d="M10.627 3.3V1.876h10.748V2a.66.66 0 0 1 .442.172.6.6 0 0 1 .183.416zm0 0h9.998v17.4h-9.998v1.425h10.748a.8.8 0 0 0 .285-.053l-.046-.117a.6.6 0 0 0 .203-.127.56.56 0 0 0 .183-.416h.125V2.588z"
          />
          <path
            fill="currentColor"
            stroke="currentColor"
            stroke-width=".25"
            d="M4.065 12.478h-.3l.211.213 3.34 3.358-.725.638-4.334-4.358a.45.45 0 0 1-.132-.312c0-.114.045-.226.129-.312l4.33-4.442.733.631-3.36 3.446-.207.212h10.628v.926z"
          />
        </mask>
        <g mask="url(#sign-out_svg__mask0_3955_5550)">
          <path fill="currentColor" d="M0 0v24h24V0z" />
        </g>
      </g>
    </svg>
  `}
//# sourceMappingURL=signOut.js.map
